import ajax from '../../helpers/ajax'
import campaignActionSharedActions, { getNewActionPayload } from '../../campaign-action-shared/store/actions'
import storeModule from '../../daisy-chains/store/module'
import { trackEvent } from '@/analytics/track'

export default {
  ...campaignActionSharedActions,
  fetchExistingSignatureByToken({ state, commit }, token) {
    ajax.get({
      url: `/petitions/${state.petition.slug}/already_signed`,
      params: {
        signature_token: token
      },
      successHandler: (resp) => {
        commit('setAlreadySigned', resp)
      }
    })
  },

  handleIfAlreadyTakenAction({dispatch}, {already_signed, existing_signature_token}) {
    if (already_signed) {
      // The CRM says that the member has already signed this petition.
      // This feature is currently only supported by Campact CRM, for signatures.
      dispatch('fetchExistingSignatureByToken', existing_signature_token)
      return true
    }
    return false
  },

  saveNewAction: async function({state, getters, commit, dispatch}, { friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken }) {
    state.retryingSubmit = false
    state.submittingCreateAction = true

    const data = getNewActionPayload(
      state, 'signature', getters.suppressEmailOptInField, { friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken }
    )

    ajax.post({
      url: state.createActionUrl,
      data,
      successHandler: (resp) => {
        // Successful signature!
        // If the response says we should redirect somewhere immediately, just do that.
        // This happens when we're in an embedded signature form, and on success we should redirect to the petition page.
        if (resp.redirectTo) {
          window.top.location = resp.redirectTo
          return
        }

        // We're not redirecting, so extract a bunch of stuff from the response to update the state.
        const { signature, baseDaisyChainsPath, campaignPath, createPetitionCommentPath, recentAction, trackingData } = resp
        state.signed = true
        state.createPetitionCommentPath = createPetitionCommentPath
        trackEvent('Signed Petition', trackingData.parameters, trackingData.identity)

        // If the page url doesn't match the petition page (which can happen if signature is from embed or facebook),
        // change page url to be a petition page url so it's shareable.
        // This does not reload the page.
        if (window.location.pathname !== campaignPath) {
          window.history.pushState({page: 'shareable_petition_page'}, '', campaignPath)
        }

        if (signature.requiresEmailConfirmation) {
          state.awaitingEmailConfirmation = true
        } else {
          // Kick off daisy chain
          dispatch('startDaisyChain', { baseDaisyChainsPath: baseDaisyChainsPath, repeatedAction: signature.repeatedAction })
        }

        // If the recent action is included in the response, add recent action to list if we already have some in the list
        if (recentAction && state.recentActions.length) {
          state.recentActions.unshift(recentAction)

          if (state.recentActions.length > 5) {
            state.recentActions.pop()
          }
        }
      },
      errorHandler: ({ info }) => {
        state.validationErrors = info.errors

        if (info.retryBotProtection) {
          if (state.retryCount < 2) {
            state.retryCount += 1
            state.retryingSubmit = true
          }
        } else {
          state.retryCount = 0
        }

        if (info.cancelOneClick) {
          commit('cancelOneClick')
        }
      }
    }).then(() => {
      state.submittingCreateAction = false
    })
  },

  startDaisyChain({ state, commit }, { baseDaisyChainsPath, repeatedAction }) {
    this.registerModule('daisyChain', storeModule)
    commit('setShowDaisyChain', true)

    let successMessageKey
    if (state.petition.signersWriteToDecisionMaker) {
      successMessageKey = 'public.daisy_chains.petitions.social_share_modal.message_sent'
    }
    else {
      successMessageKey = 'public.daisy_chains.petitions.signature_recorded'
    }

    commit('daisyChain/initializeDaisyChain', {
      pageKind: 'petition',
      baseUrl: baseDaisyChainsPath,
      previousStepKind: null,
      repeatedAction,
      successMessageKey,
      thanksMessageKey: 'public.daisy_chains.petitions.thanks_for_support'
    })
  },

  trackSawOneClick({state}) {
    trackEvent('Saw petition one-click signature', {
      action: 'one-click-signature',
      category: 'petition',
      name: state.petition.slug,
      petition: state.petition.slug
    })
  }
}
